import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Box from "../../uikit/box/Box";
import Text from "../../uikit/text/Text";
import Button from "../../uikit/button/Button";
import { useForm } from "react-hook-form";
import TextField from "../../uikit/form/textfield/TextField";
import { observer, inject } from "mobx-react";

import { string, object, ref } from "yup";
import { mapServerErrors } from "../../../lib/utils";

import './Auth.css';
import { observable } from "mobx";
import Modal from "../../uikit/modal/Modal";
import PrivacyPolice from "./privacy/PrivacyPolice";

const Schema = object().shape({
    email_address: string()
        .email()
        .required("Email is required").label('Email'),
});


function TryForFree(props) {
    const history = useHistory();
    const { register, handleSubmit, errors } = useForm({
        validationSchema: Schema
    });


    const [serverErrors, setServerErrors] = useState(null);
    const [email, setEmail] = useState(null);
    const [modalOpenState, setModalOpenState] = useState(false);

    const handleEmailChange = value => {
        setEmail(value);
        props.authStore.setEmail(value);
    }

    const onSubmit = (data) => {
        history.push('/register', { replace: true });
    };

    return (
        <Box p={[6, 7]} bg="primarys.0" boxShadow={1} maxWidth="75%" margin="auto" marginTop="3vh">
            <Text color="white" fontSize={12} textAlign="center" mb={4}>
                Try Agency Minder for free
            </Text>
            <Text color="white" fontSize={8} textAlign="center" mb={4} style={{ lineHeight: '1.7' }}>
                Free 14 days, cancel anytime. Please sign up with your work email<br />
                address so you can connect with your work team.
            </Text>

            <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <Box my={5} maxWidth="330px" margin='auto' bg="#ffffff" style={{ marginTop: '50px' }}>
                    <TextField
                        required
                        name="email_address"
                        ref={register}
                        error={errors.email_address && errors.email_address.message}
                        placeholder="email"
                        color="#111111"
                        style={{ fontSize: "16px", paddingLeft: '20px', lineHeight: '1.5' }}
                        onChange={event => handleEmailChange(event.target.value)}
                    />
                </Box>

                <Button
                    variant="primary"
                    size="large"
                    width="220px"
                    onClick={handleSubmit(onSubmit)}
                    style={{ display: 'block', margin: 'auto', marginTop: '3vh' }}
                >
                    Try for Free
                </Button>
            </form>
            <Text color="white" fontSize={8} textAlign="center" mb={4} marginTop="10vh">
                By signing up, I agree to the Agency Minder <div onClick={() => setModalOpenState(true)} style={{ display: 'contents', cursor: 'pointer', textDecoration: 'underline' }}>
                    Privacy Policy
                </div>
            </Text>
            <Modal
                backgroundTitle={"#ffffff"}
                maxWidth={"80vw"}
                isOpen={modalOpenState}
                iconSize={40}
                onRequestClose={() => {
                    setModalOpenState(false)
            }}>
                <PrivacyPolice />
            </Modal>
        </Box>
    )
}

export default inject("authStore")(observer(TryForFree));
